export enum Plat {
  h5 = 'h5',
  pc = 'pc'
}
const removeEvent = (event: any) => {
  event.preventDefault()
}
const touchstartEvnt = (event: any) => {
  if (event.touches.length > 1) {
    event.preventDefault()
  }
}

const touchendEvnt = (event: any) => {
  const now = (new Date()).getTime()
  if (now - lastTouchEnd <= 300) {
    event.preventDefault()
  }
  lastTouchEnd = now
}

let lastTouchEnd = 0

/** 设置对应平台的view */
export const setViewPort = (type: Plat) => {
  const mateTag = document.querySelector('meta[name="viewport"]')
  const content = mateTag?.getAttribute('content') || ''
  const width = Number(/^width=(\d*)/.exec(content)?.[1] || 1200)
  if (type === Plat.h5) {
    document.addEventListener('gesturestart', removeEvent)
    document.addEventListener('touchstart', touchstartEvnt)
    document.addEventListener('touchend', touchendEvnt, false)
  } else {
    document.removeEventListener('gesturestart', removeEvent)
    document.removeEventListener('touchstart', touchstartEvnt)
    document.removeEventListener('touchend', touchendEvnt, false)
  }
  if (type === Plat.h5 && width === 1200) {
    mateTag?.setAttribute('content', 'width=375,initial-scale=1.0,maximum-scale=1.0, minimum-scale=1.0,user-scalable=no')
  }
  if (type === Plat.pc && width === 375) {
    mateTag?.setAttribute('content', 'width=1200')
  }
}

// 推广插件介入
interface FormType {
  // 登录名
  loginName: string
  // 邮箱
  email: string
  // 渠道pc h5
  device: string
  // 手机号
  mobile: string
  // channel
  channel: string
  // uuid
  uuid: string
}
export const promotionPluginFn = (form:FormType) => {
  console.log('promotionPluginFn', form)
  const w: any = window
  switch (form.channel) {
    case 'a8net':
      loadA8()
      break
    case 'valuecommerce':
      loadValuecommerce(form)
      break
  }
  function loadA8 () {
    w.a8sales({
      pid: 's00000024639001',
      order_number: new Date().getTime() + '_' + form.uuid + '_' + form.device,
      currency: 'JPY',
      items: [
        {
          code: 'signup',
          price: 1,
          quantity: 1
        }
      ],
      total_price: 1
    })
  }
  // loadScriptRTCV(form, w)
  // loadValuecommerce(form)
}
const loadScriptRTCV = (form:FormType, w:any) => {
  w._rt.sid = 8259
  w._rt.pid = 11691
  w._rt.price = 0
  w._rt.reward = -1
  w._rt.cname = ''
  w._rt.ctel = ''
  w._rt.cemail = ''
  w._rt.cinfo = form.loginName + '_' + form.device + '_' + new Date().getTime()
  w.rt_tracktag()
}

const loadValuecommerce = (form:FormType) => {
  // const divElement = document.createElement('div')
  const divElement = document.querySelector('div[data-vc-ec-id="3704333"]')
  // divElement?.setAttribute('data-vc-ec-id', '3704333')
  divElement?.setAttribute('data-vc-order-id', encodeURIComponent(new Date().getTime() + '_' + form.uuid + '_' + form.device))
  // divElement?.setAttribute('data-vc-sales-name', encodeURIComponent(form.loginName))
  // divElement?.setAttribute('data-vc-sales-tel', encodeURIComponent(form.mobile))
  // divElement?.setAttribute('data-vc-sales-email', encodeURIComponent(form.email))
  // divElement?.setAttribute('data-vc-cs', '')
  divElement?.setAttribute('data-vc-uid', encodeURIComponent(form.uuid))
  divElement && document.querySelector('body')?.append(divElement)
  // const scriptLp:any = document.createElement('script')
  // scriptLp.type = 'text/javascript'
  // scriptLp.src = '//trj.valuecommerce.com/vclp.js'
  // document.getElementsByTagName('body')[0].appendChild(scriptLp)
  const script:any = document.createElement('script')
  script.type = 'text/javascript'
  script.src = '//cv.valuecommerce.com/vccv.min.js'
  document.getElementsByTagName('body')[0].appendChild(script)
}

// 这儿之后是给买会员写的
interface isFirst {
  channel: string
  isFirstRecharge: boolean
  membershipTemplatId: number
  rechargeAmount: number
  rechargeTime: string
  registerTime: string
  superCustomerId: number
  loginName: string
  level: number
}
export const promotionPluginFnMember = (data:isFirst) => {
  console.log('promotionPluginFn_member')
  switch (data.channel) {
    case 'a8net':
      a8net(data)
      break
    case 'valuecommerce':
      memberValuecommerce(data)
      break
  }
}

const BuryingCode = {
  register: 'SNIFFFREE001',
  1: 'SNIFF001',
  2: 'SNIFF002'
} as const

const a8net = (data: isFirst, code = '') => {
  const w: any = window
  w.a8sales({
    pid: 's00000024639001',
    order_number: new Date().getTime() + '_' + data.loginName,
    currency: 'JPY',
    items: [
      {
        code: code || (BuryingCode as any)[data.level],
        price: 1,
        quantity: 1
      }
    ],
    total_price: 1
  })
}

const memberValuecommerce = (data: isFirst) => {
  const divElement = document.createElement('div')
  divElement.setAttribute('data-vc-ec-id', '3704333')
  // divElement.setAttribute('data-vc-order-id', encodeURIComponent(form.device + '_' + new Date().getTime()))
  // divElement.setAttribute('data-vc-sales-name', encodeURIComponent(form.loginName))
  // divElement.setAttribute('data-vc-sales-tel', encodeURIComponent(form.mobile))
  // divElement.setAttribute('data-vc-sales-email', encodeURIComponent(form.email))
  divElement.setAttribute('data-vc-cs', '')
  divElement.setAttribute('data-vc-uid', '')
  document.querySelector('body')?.append(divElement)
  const script:any = document.createElement('script')
  script.type = 'text/javascript'
  script.src = '//cv.valuecommerce.com/vccv.min.js'
  document.getElementsByTagName('head')[0].appendChild(script)
}
